"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElemRect = exports.useRect = exports.getRect = void 0;
const react_1 = require("react");
function getRect(element) {
    let rect = initialState;
    if (element) {
        const domRect = element.getBoundingClientRect();
        rect = domRect;
    }
    return rect;
}
exports.getRect = getRect;
function useRect(ref, refresher) {
    const [dimensions, setDimensions] = (0, react_1.useState)(initialState);
    const handleResize = (0, react_1.useCallback)(() => {
        if (!(ref === null || ref === void 0 ? void 0 : ref.current))
            return;
        setDimensions(getRect(ref === null || ref === void 0 ? void 0 : ref.current));
    }, [ref === null || ref === void 0 ? void 0 : ref.current]);
    (0, react_1.useEffect)(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [ref === null || ref === void 0 ? void 0 : ref.current, refresher]);
    return dimensions;
}
exports.useRect = useRect;
function useElemRect(elem, refresher) {
    const [dimensions, setDimensions] = (0, react_1.useState)(initialState);
    const handleResize = (0, react_1.useCallback)(() => {
        if (!elem)
            return;
        setDimensions(getRect(elem));
    }, [elem]);
    (0, react_1.useEffect)(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [elem, refresher]);
    return dimensions;
}
exports.useElemRect = useElemRect;
const initialState = {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0,
};
//# sourceMappingURL=useRect.js.map